import React, { useEffect, useMemo, useState } from "react";
import DatePicker from "@components/datePicker/DatePicker";
import "./Schedule.scss";
import dayjs from "dayjs";
import CardSchedule from "@components/cardSchedule/CardSchedule";
import { observer } from "mobx-react-lite";
import { useMst } from "@store/Route";
import { toJS } from "mobx";
import SchedulePlaceHolder from "./component/SchedulePlaceHolder";
import { BsExclamationTriangle } from "react-icons/bs";
import { useHistory } from "react-router-dom";

const Schedule = observer(() => {
  const { schedules, landing, assigment, schedulePermissions, renewal } =
    useMst();
  const {
    getListSchedules,
    fetching,
    listSchedules,
    getListHolidays,
    listHolidays,
    getViewHoliday,
    postNotTakingReported,
    holidays,
  } = schedules;
  const { getAssigment } = assigment;
  const { getListChilds, listChildren } = schedulePermissions;
  const { token, userId } = landing;
  const { getRenewalScheduleChild } = renewal;
  const { push } = useHistory();
  const [startDate, setStartDate] = useState<Date | null>(new Date());
  const [selectMonth, setSelectMonth] = useState<Date | null>(new Date());
  const [isLoading, setIsLoading] = useState(false);
  const [isAlertRenewal, setIsAlertRenewal] = useState(false);
  const [renewalDate, setRenewalDate] = useState("");

  useEffect(() => {
    let timerFunc = setTimeout(() => {
      if (startDate && token) {
        const year = startDate.getFullYear();
        const month = startDate.getMonth();
        const date = startDate.getDate();
        const fromDate = dayjs(`${year - 1}-${month}-${date}`).format(
          "YYYY-MM-DD"
        );
        const toDate = dayjs(`${year + 1}-${month}-${date}`).format(
          "YYYY-MM-DD"
        );
        getListHolidays(token, fromDate, toDate);
      }
    }, 1500);

    return () => clearTimeout(timerFunc);
  }, [startDate]);

  useEffect(() => {
    setIsLoading(true);
    let timerFunc = setTimeout(() => {
      if (token) {
        getListSchedules(token, dayjs(startDate).format("YYYYMMDD"));
      }
    }, 1000);

    return () => clearTimeout(timerFunc);
  }, [startDate]);

  useEffect(() => {
    if (fetching !== "pending") {
      setIsLoading(false);
    }
  }, [fetching]);

  const viewHoliday = useMemo(
    () => getViewHoliday(dayjs(selectMonth).format("YYYY MM")),
    [selectMonth]
  );

  useEffect(() => {
    if (token && userId) {
      getListChilds(token, userId, 1, 100);
    }
  }, [token]);

  useEffect(() => {
    const tempChildren = toJS(listChildren);
    if (tempChildren && tempChildren.length > 0 && token) {
      getRenewalScheduleChild(token, listChildren, (callback) => {
        if (callback.status === "pending") {
          setIsAlertRenewal(true);
          setRenewalDate(callback?.nextAcademicYear?.earlyRegistrationEndDate);
        }
      });
    }
  }, [JSON.stringify(toJS(listChildren))]);

  return (
    <section className="Schedule">
      {isAlertRenewal ? (
        <div className="mb-8 bg-yellow-300 p-7 rounded-lg">
          <div className="flex flex-row space-x-4">
            <BsExclamationTriangle
              style={{ width: 20, height: 20 }}
            ></BsExclamationTriangle>
            <div className="w-full">
              <h1 className="text-2xl font-semibold">
                Next Academic Year Renewal is Due
              </h1>
              <p className="text-xl w-full">
                {`Please renew your bus service before ${dayjs(
                  renewalDate
                ).format("DD-MM-YYYY")}. Please click `}
                <a
                  onClick={() => {
                    push("/dashboard/manage/child");
                  }}
                  className="font-semibold cursor-pointer"
                >
                  here
                </a>{" "}
                for more information
              </p>
            </div>
          </div>
        </div>
      ) : null}
      <p className="mt-3">
        <span className="header--30 me-3 color--white">
          {dayjs(startDate).format("ddd")}
        </span>
        <span className="bodyLight--30 color--white">
          {dayjs(startDate).format("DD MMM YYYY")}
        </span>
      </p>

      <div className="row d-flex flex-row-reverse">
        <div className="col-md-4">
          <div className="Schedule__sectionWrapper_one">
            <h1 className="header--18 color--white mt-5 Schedule__headerSub">
              Calender
            </h1>
          </div>
          <div
            className={`Calendar__mainWrapper clearfix ${
              getViewHoliday(dayjs(selectMonth).format("YYYY MM")).length > 0 &&
              "is--hasHoliday"
            }`}
          >
            <DatePicker
              inline
              selected={startDate}
              onChange={(dateVal: Date) => {
                setStartDate(dateVal);
                console.log(dateVal);
              }}
              onMonthChange={(dateVal: Date) => {
                setSelectMonth(dateVal);
                console.log(dateVal);
              }}
              highlightDates={[
                {
                  "is--holiday":
                    listHolidays(dayjs(selectMonth).format("YYYY MM")) || [],
                },
              ]}
              peekNextMonth={false}
            />
            {viewHoliday.length > 0 && (
              <div className="Calendar__holidayWrapper">
                {viewHoliday.map((item, index) => {
                  return (
                    <div key={index} className="clearfix Calendar__itemWrapper">
                      <span className="Calendar__textDate">
                        {dayjs(item.date).format("D MMM YYYY")}
                      </span>
                      <span className="Calendar__textLabel">{item.name}</span>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        <div className="col-md-8">
          <div className="Schedule__sectionWrapper_one mb-5">
            <h1 className="header--18 color--white mt-5 Schedule__headerSub">
              Schedule
            </h1>
          </div>
          {isLoading ? (
            <SchedulePlaceHolder />
          ) : listSchedules && listSchedules.length !== 0 ? (
            listSchedules.map((item) => {
              return (
                <CardSchedule
                  key={item.id}
                  item={toJS(item)}
                  token={token || ""}
                  getAssigment={getAssigment}
                  postNotTakingReported={postNotTakingReported}
                  getSchedule={() => {
                    if (token)
                      getListSchedules(
                        token,
                        dayjs(startDate).format("YYYYMMDD")
                      );
                  }}
                  date={startDate || new Date()}
                />
              );
            })
          ) : (
            <div className="noBusSchedule__mainWrapper">
              <div className="noBusSchedule__ico" />
              <p className="text-center header--16 color--blue noBusSchedule__copy">
                There is no Schedule today.
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
});

export default Schedule;
